module.exports = __webpack_public_path__ + "static/transition-fab72f29b2b306b4f3a668cf6d06ee57.mp4";